import React from "react";
import usePrevious from "./usePrevious";
/**
 * Not exported
 *
 * This hook is used in conjunction with the DataList component.
 *
 * @param data
 * @param pageSize
 * @param page
 * @param lastPageToken
 * @param args
 */
const useDataList = (data, pageSize, page, lastPageToken, args) => {
    // state
    let [loading, setLoading] = React.useState(false);
    let [error, setError] = React.useState(null);
    let [hasMore, setHasMore] = React.useState(false);
    let [items, setItems] = React.useState([]);
    let [pageToken, setPageToken] = React.useState(null);
    let [total, setTotal] = React.useState(null);
    let prevPage = usePrevious(page);
    let prevPageToken = usePrevious(lastPageToken);
    let prevArgs = usePrevious(args);
    let prevData = usePrevious(data);
    // if arguments changed reset items list
    React.useEffect(() => {
        setItems([]);
    }, [args]);
    React.useEffect(() => {
        if (!lastPageToken)
            setItems([]);
    }, [lastPageToken]);
    React.useEffect(() => {
        if (page == 0)
            setItems([]);
    }, [page]);
    React.useEffect(() => {
        if (page != prevPage || lastPageToken != prevPageToken || args != prevArgs || data != prevData) {
            filterDataItems();
        }
    }, [page, lastPageToken, args, data]);
    const filterDataItems = () => {
        // loading
        setLoading(true);
        // filter
        if (typeof data == "function") {
            data(pageSize, lastPageToken, args).then((response) => {
                const newItems = page == 0 ? response.items : [...items, ...response.items];
                setItems(newItems);
                setLoading(false);
                setPageToken(response.pageToken);
                if (response.total !== undefined && response.total !== null) {
                    setTotal(response.total);
                    setHasMore(newItems.length < response.total);
                }
                else {
                    setHasMore(response.items.length >= pageSize);
                }
            });
        }
        else {
            setItems(data);
            setTotal(data.length);
            setHasMore(false);
            setLoading(false);
        }
    };
    function removeItem(key) {
        let _items = [...items];
        _items.splice(key, 1);
        setItems(_items);
    }
    function updateItem(key, item) {
        let _items = [...items];
        _items[key] = item;
        setItems(_items);
    }
    return {
        items,
        pageToken,
        hasMore,
        loading,
        error,
        total,
        removeItem,
        updateItem
    };
};
export default useDataList;
